export const getProjectContainerScope = (projectId: number | string) => `project-${projectId}`;

export const getCollectionContainerScope = (collectionUUID: string) =>
	`collection-${collectionUUID}`;
